import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rate-fixation-form',
  templateUrl: './rate-fixation-form.component.html',
  styleUrls: ['./rate-fixation-form.component.css']
})
export class RateFixationFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/rate-fixation/rate-fixation-form/rate-fixation-form.component.ts